import { Link } from "react-router-dom";
import { stats } from "@/mocks/site";

export default function SiteIntro() {
  return (
    <section className="bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-accent-700 uppercase mb-3">
              <span className="w-5 h-px bg-accent-500"></span>
              About Us
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-[32px] font-bold text-foreground-950 leading-snug">
              关于「欲望的诱惑」
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-loose">
              「欲望的诱惑」是一个专注影视内容资讯与深度解读的门户站点。我们把散落在各处的影视动态、剧情梗概与演员资料重新整理成清晰、好读的档案，帮助每一位热爱影像的观众，在海量作品里快速找到自己想要的那一部。
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-loose">
              从大银幕电影到长篇剧集，从纪实影像到动画世界，我们持续更新最新收录作品，并推出编辑精选专题合集，让追剧不再盲目。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                href="/about"
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解我们
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                href="/contact"
                to="/contact"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-100 text-foreground-800 border border-background-300/70 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                联系我们
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {stats.map((s) => (
              <div
                key={s.label}
                className="bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6"
              >
                <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600">{s.value}</p>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}